const MY_ACCOUNT = "Account Settings"
const PODCAST_SETTINGS = "Podcast Settings"
const SUBSCRIPTION_AND_BILLING = "Subscription & Billing"
const NOTIFICATIONS = "Notifications"
const TELL_YOUR_FRIENDS = "Tell Your Friends!"

export { MY_ACCOUNT, PODCAST_SETTINGS, SUBSCRIPTION_AND_BILLING, NOTIFICATIONS, TELL_YOUR_FRIENDS }
